import React from 'react';
import { IIconProps } from './utils';

export const Print = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.5 11.25V5C7.5 4.30964 8.05964 3.75 8.75 3.75H16.25M7.5 11.25H22.5M7.5 11.25C5.42893 11.25 3.75 12.9289 3.75 15V17.5C3.75 19.5711 5.42893 21.25 7.5 21.25H9.375M21.25 3.75C21.9404 3.75 22.5 4.30964 22.5 5V11.25M22.5 11.25C24.5711 11.25 26.25 12.9289 26.25 15V17.5C26.25 19.5711 24.5711 21.25 22.5 21.25H20.625M20.625 21.25V16.25H16.25H9.375V21.25M20.625 21.25V25C20.625 25.6904 20.0654 26.25 19.375 26.25H10.625C9.93464 26.25 9.375 25.6904 9.375 25V21.25"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
